<div class="vm-form-group__control">
  <div class="input-group vm-file-upload-auto">
    <!-- <div class="custom-file"> -->
    <input type="file"
           [multiple]="multiple"
           class="form-control"
           [required]="required"
           (focus)="onTouched()"
           id="file_{{ name }}"
           (change)="filechange($event)"
           [accept]="accept"
           [disabled]="disabled" />
    <!-- <label
      class="input-group-text"
      *ngIf="value == null; else filenameTemplate"
      for="file_{{ name }}"
    >
      <span></span>Browse
    </label> -->
    <div class="input-group-append vm-fileUpload-btn">
      <label for="file_{{ name }}" class="btn btn__secondary" [ngClass]="disabled?'disabled':''">Browse</label>
      <ng-container *ngIf="isuploadButton">
        <button class="btn btn__primary ms-1 vm-btn-border-radius"
                (click)="onUpload($event)"
                [disabled]="value == null || value.length == 0">
          Upload
        </button>
      </ng-container>
    </div>
    <!-- <ng-template #filenameTemplate>
      <label class="custom-file-label">
        <span *ngIf="value.length == 1; else filesCountTemplate">{{
          value[0].name
        }}</span>
      </label>
    </ng-template>
    <ng-template #filesCountTemplate> {{ value.length }} files </ng-template> -->
    <!-- </div> -->

  </div>
  <div class="fileupload_err_msg_btm">
    <div class="p-message" *ngFor="let error of file_errorsList; let i = index">
      <span class="p-message-icon pi pi-times-circle"></span>
      <span class="p-message-summary">{{ error.name }}</span>
      <span class="p-detail-summary">{{ error.message }}</span>
      <button type="button"
              pripple=""
              class="p-ripple p-element p-message-close p-link ng-tns-c93-5 ng-star-inserted ms-auto"
              (click)="file_remove(i)">
        <i class="p-message-close-icon pi pi-times ng-tns-c93-5"></i><span class="p-ink p-error-template-message"></span>
      </button>
    </div>
  </div>
</div>
